module.exports = __webpack_public_path__ + "static/media/pores_forehead.55f0ae22.svg";